module.exports = __webpack_public_path__ + "img/20220219_072056.d8ef8f46.jpg";